export const AuthActions = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  UPDATE: 'UPDATE',
};
